import { FC } from 'react';

import { ImageField } from '../ImageField/ImageField';
import { ImageType } from '../ImageField/ImageField.types';
import { IImageUploaderProps } from './ImageUploader.types';

export const ImageUploader: FC<IImageUploaderProps> = (props) => {
  const {
    className = '',
    input: { name, onChange, value },
    renderImage,
    customNoImage = null,
    imageType = ImageType.ROUND,
    onLoad,
  } = props;

  return (
    <ImageField
      className={className}
      name={name}
      value={value}
      renderImage={renderImage}
      emptyImage={customNoImage}
      type={imageType}
      onChange={onChange}
      onLoad={onLoad}
    />
  );
};
